import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

interface IPostBatchInvoiceButton {
  rateChartId: number;
}

const PostBatchInvoiceButton = ({ rateChartId }: IPostBatchInvoiceButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusStudent, { loading }] = useMutation(
    {
      type: "customCreate",
      resource: `ratecharts/${rateChartId}/postinvoices`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully post the invoices.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed post the invoices, error: ${error.message}`, "warning"),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusStudent}
      color="primary"
      label={loading ? "Please wait..." : "POST"}
      style={{ backgroundColor: "#1976d2" }}
    >
      <CheckCircleIcon />
    </Button>
  );
};

export default PostBatchInvoiceButton;
